import i18n from "i18n";

/**
 * Returns array of objects sorted by given keys and corresponding order.
 *
 * @template {Record<string, string|number|BigInt|boolean>} Record
 *
 * @param {Record[]} array - The collection to iterate over.
 * @param {Array<keyof Record>} keys - The keys to sort by.
 * @param {('asc'|'desc')[]} [orders] - The sort orders of the keys. Defaults to "asc" order.
 * @returns {Record[]}
 *
 * Replaces lodash orderBy function.
 * @see https://lodash.com/docs/#orderBy
 */
export const orderBy = (array, keys, orders = []) => {
  return [...array].sort((a, b) => {
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const order = orders[i] || "asc";
      const aVal = a[key];
      const bVal = b[key];

      if (aVal < bVal) return order === "asc" ? -1 : 1;
      if (aVal > bVal) return order === "asc" ? 1 : -1;
    }
    return 0;
  });
};

export const mapLocalizableObjectsToOptions = (
  arrayOfObj,
  labelKey = "name",
  valKey = "id",
  sort = true
) => {
  let localizedList = arrayOfObj.map(obj => {
    let label = obj[labelKey][i18n.language] || obj[labelKey]['en'];
    let value = obj[valKey];

    return { label, value };
  });

  if (sort) {
    localizedList = localizedList.sort((a, b) => {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return +1;
      return 0;
    });
  }

  return localizedList;
};

export const isEventKeyBackspace = (event) => {
  if (event.key === "Backspace")
    return true;
  if (event.keyCode === 8)
    return true; // Compatibility

  return false;
};

export const isEventKeyEsc = (event) => {
  if (event.key === "Esc")
    return true;
  if (event.keyCode === 27)
    return true; // Compatibility

  return false;
};

export const keyReducer = (key) => {
  return (acc, cur) => {
    acc[cur[key]] = cur;
    return acc;
  };
};
